<wchfs-icon (click)="changePasswordIcon()" *ngIf="!showPassword" [svgIcon]="'wchfs:pass-show'"></wchfs-icon>
<wchfs-icon (click)="changePasswordIcon()" *ngIf="showPassword" [svgIcon]="'wchfs:hide'"></wchfs-icon>
